import type { FC } from 'react'

import RadioInput from '@/components/RadioInput'
import type { Document } from '@/lib/apollo/query/get-applicant'

import PreviewDocument from './PreviewDocument'

interface Props {
  name: string
  document: Document
  checked: boolean
  onChange: () => void
  disabled?: boolean
}

const DocumentRadioInput: FC<Props> = ({
  name,
  document,
  checked,
  onChange,
  disabled,
}) => (
  <RadioInput
    name={name}
    checked={checked}
    onChange={onChange}
    value={document.id}
    disabled={disabled}
  >
    <PreviewDocument document={document} />
  </RadioInput>
)

export default DocumentRadioInput
